module.exports = __webpack_public_path__ + "static/media/Bulk Upload Status Dealshub.c1d1dc11.xlsx";